import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { Sailboat, Hotel, Compass } from 'lucide-react';

import { setActiveCategory, getActiveCategory } from '../../reducers/category';
import { CATEGORY_CONFIG } from '../../config/categoryConfig';

import s from './CategorySelector.css';

const ICONS = {
    Sailboat,
    Hotel,
    Compass
};

class CategorySelector extends React.Component {
    static propTypes = {
        activeCategory: PropTypes.string.isRequired,
        setActiveCategory: PropTypes.func.isRequired,
    };

    handleCategoryChange = (categoryId) => {
        const { setActiveCategory } = this.props;
        setActiveCategory(categoryId);
    };

    render() {
        const { activeCategory } = this.props;

        return (
            <div className={s.selectorContainer}>
                {Object.values(CATEGORY_CONFIG).map((cat) => {
                    const IconComponent = ICONS[cat.icon];
                    const isActive = activeCategory === cat.id;

                    return (
                        <button
                            key={cat.id}
                            type="button"
                            className={cx(s.categoryTab, { [s.active]: isActive })}
                            onClick={() => this.handleCategoryChange(cat.id)}
                            aria-pressed={isActive}
                        >
                            {IconComponent && <IconComponent size={20} className={s.icon} />}
                            <span className={s.label}>{cat.label}</span>
                        </button>
                    );
                })}
            </div>
        );
    }
}

const mapState = (state) => ({
    activeCategory: getActiveCategory(state),
});

const mapDispatch = {
    setActiveCategory,
};

export default withStyles(s)(connect(mapState, mapDispatch)(CategorySelector));
